module.exports = "<div class=\"kan-user-container\">\n  <div>\n    <button mat-button color=\"accent\" (click)=\"goBack($event)\">\n      <mat-icon aria-label=\"Go back\">keyboard_arrow_left</mat-icon>\n      <span class=\"kan-button-label\">{{'ADMIN.USER.GO_BACK' | translate}}</span>\n    </button>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/modules/admin/components/user/user/component.html
// module id = ./src/modules/admin/components/user/user/component.html
// module chunks = main